import React from "react";
import { FaBolt } from "react-icons/fa";

export const ChallengesTab: React.FC<{ hubName?: string }> = ({ hubName }) => (
    <div className="hcs-empty">
        <FaBolt />
        <h3>No challenges yet</h3>
        <p>When brands sponsor challenges with {hubName ?? "this creator"}, they'll appear here. Visitors will be able to participate to earn XP and unlock rewards.</p>
    </div>
);
